import { cn } from '@/utils/cn';
interface Props {
  isBlack: boolean;
}
export default function Skeleton({
  isBlack
}: Props) {
  return <div className={cn('absolute left-0 top-0 h-22 w-full lg:h-30', isBlack ? 'bg-blackFriday' : 'bg-white')} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between lg:px-32'>
                <div className='flex flex-col items-center justify-center'>
                    <div className={cn('mb-1 h-12 w-12 animate-pulse rounded-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-20 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <div className={cn('mb-1 h-12 w-12 animate-pulse rounded-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-20 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <div className={cn('mb-1 h-12 w-12 animate-pulse rounded-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-20 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <div className={cn('mb-1 h-12 w-12 animate-pulse rounded-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-20 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
                <div className='hidden flex-col items-center justify-center md:flex'>
                    <div className={cn('mb-1 h-12 w-12 animate-pulse rounded-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-20 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
                <div className='hidden flex-col items-center justify-center md:flex'>
                    <div className={cn('mb-1 h-12 w-12 animate-pulse rounded-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-20 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
                <div className='flex flex-col justify-center md:hidden'>
                    <div className={cn('mb-1 h-12 w-6 animate-pulse rounded-s-full lg:mb-4 lg:h-16 lg:w-16', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                    <div className={cn('h-5 w-6 animate-pulse rounded lg:h-6 lg:w-35', isBlack ? 'bg-neutral-800' : 'bg-gray-100')} />
                </div>
            </div>
        </div>;
}